"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  primary: {
    display: 'inline-block',
    color: 'black',
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    textDecoration: 'none',
    ':hover': {
      textDecoration: 'underline'
    }
  },
  nav: {
    textTransform: 'uppercase',
    fontFamily: 'mrEaves',
    fontWeight: 'bold',
    fontSize: 6
  }
};
exports.default = _default;